import { render, staticRenderFns } from "./NegativeFeedbackLeaveMessage.vue?vue&type=template&id=7edc0d1c"
import script from "./NegativeFeedbackLeaveMessage.vue?vue&type=script&lang=js"
export * from "./NegativeFeedbackLeaveMessage.vue?vue&type=script&lang=js"
import style0 from "./NegativeFeedbackLeaveMessage.vue?vue&type=style&index=0&id=7edc0d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports